module.exports = __webpack_public_path__ + "static/img/18.c69d56e.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/4/2/1/eng/18.png
// module id = GHew
// module chunks = 0